module.exports = __webpack_public_path__ + "static/media/icon-jzb.ebed8ee3.png";